

<!--<input class="burton-input"/>-->
<!--<button class="burton-button"></button>-->

<div class="center-title" >
<h1 [@fadeInTrigger]="titleState" (@fadeInTrigger.done)="onTitleFadedIn($event)">Twisted</h1 >

  <button class="burton-button" (click)="navigateToStart()" [@fadeInTrigger]="beginButtonState">Begin</button>
</div>


